<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-setting-up',
    }"
  >
    <h4 class="mt-6 mb-9">
      Thanks for signing up, {{ firstName }}!
    </h4>

    <p class="p3 mb-6">
      We want you to have the best possible JobNav experience. Since your email domain isn’t
      currently linked to an active account, we’re checking to see if you might be part of one.
    </p>

    <p class="p3 mb-6">
      If we find a match, you’ll receive an email with next steps. If not, someone from our
      New Accounts team will reach out to learn more about
      {{ companyName || 'your company' }} and help you get started.
    </p>

    <p class="p3">
      We’re excited to connect - keep an eye on your inbox!
    </p>
  </WizardContent>
</template>

<script>
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';
import WizardContent from '@/components/shared/WizardContent.vue';

export default {
  name: 'ProjectNotAssigned',

  components: {
    WizardContent,
  },

  emits: ['track-page-load'],

  computed: {
    ...mapState(useWizard, ['companyName', 'firstName']),
  },

  beforeCreate() {
    this.$emit('track-page-load', { page: 'Project Not Assigned' });
  },
};
</script>
